module.exports = __webpack_public_path__ + "static/media/Chattukam-R.3f4ebf95.jpg";